'use client';
import { _ as _objectWithoutProperties, a as _extends } from './objectWithoutProperties-0d2f976c.esm.js';
import { _ as _slicedToArray } from './slicedToArray-7f123e5d.esm.js';
import { a as _objectSpread2 } from './objectSpread2-489e77e9.esm.js';
import { VideoUi } from './video-ui-eca6324d.esm.js';
import { LoadingSpinner, Button, Image } from '@cue/atoms';
import { useMediaAnalytics } from '@cue/hooks';
import { BrowserUtil } from '@cue/utility';
import canAutoPlay from 'can-autoplay';
import { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { jsx } from '@emotion/react';

var _excluded = ["isLive", "uiElements", "excludeUiElements", "startTime", "showUnmuteButton", "trackingTitle", "trackingType", "videoType", "useMediaAnalytics", "noUi", "customWrapper", "onProgressUpdate", "poster", "hls"];
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
//if (typeof window !== 'undefined') window.Hls = hsl;

var VideoTypes = /*#__PURE__*/function (VideoTypes) {
  VideoTypes["Live"] = "Live";
  VideoTypes["VoD"] = "VoD";
  VideoTypes["Default"] = "Default";
  return VideoTypes;
}({});
var Video = /*#__PURE__*/forwardRef(function Video(props, ref) {
  /* export const Video: React.FC<VideoProps> = (props) => { */
  var isLive = props.isLive,
    uiElements = props.uiElements,
    excludeUiElements = props.excludeUiElements,
    startTime = props.startTime,
    showUnmuteButton = props.showUnmuteButton,
    trackingTitle = props.trackingTitle,
    trackingType = props.trackingType,
    _props$videoType = props.videoType,
    videoType = _props$videoType === void 0 ? VideoTypes.Default : _props$videoType,
    _props$useMediaAnalyt = props.useMediaAnalytics,
    useMediaAnalyticsProp = _props$useMediaAnalyt === void 0 ? useMediaAnalytics : _props$useMediaAnalyt,
    noUi = props.noUi,
    customWrapper = props.customWrapper,
    onProgressUpdate = props.onProgressUpdate,
    poster = props.poster,
    hls = props.hls,
    restProps = _objectWithoutProperties(props, _excluded);

  // AUTOPLAY BY DEFAULT
  var rest = restProps.playing !== undefined ? restProps : _objectSpread2(_objectSpread2({}, restProps), {}, {
    playing: true
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playerInited = _useState2[0],
    setPlayerInited = _useState2[1];
  var player = useRef(null);
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showPoster = _useState4[0],
    setShowPoster = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    setCurrentPlayer = _useState6[1];
  var videoWrapper = useRef(null);
  var _useState7 = useState(rest),
    _useState8 = _slicedToArray(_useState7, 2),
    playerProps = _useState8[0],
    setPlayerProps = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    playerProgress = _useState10[0],
    setPlayerProgress = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    playerDuration = _useState12[0],
    setPlayerDuration = _useState12[1];
  var _useState13 = useState(true),
    _useState14 = _slicedToArray(_useState13, 2),
    loading = _useState14[0],
    setLoading = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    nativeControls = _useState16[0],
    setNativeControls = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    unmutedLayerRemoved = _useState18[0],
    setUnmutedLayerRemoved = _useState18[1];
  useImperativeHandle(ref, function () {
    var impReturn = {
      play: function play() {
        setPlayerProps(_objectSpread2(_objectSpread2({}, playerProps), {}, {
          playing: true
        }));
      },
      pause: function pause() {
        setPlayerProps(_objectSpread2(_objectSpread2({}, playerProps), {}, {
          playing: false
        }));
      },
      stop: function stop() {
        var _player$current;
        setPlayerProps(_objectSpread2(_objectSpread2({}, playerProps), {}, {
          playing: false
        }));
        player === null || player === void 0 || (_player$current = player.current) === null || _player$current === void 0 || _player$current.seekTo(0);
        setShowPoster(true);
      },
      seekTo: function seekTo(position) {
        var _player$current2;
        player === null || player === void 0 || (_player$current2 = player.current) === null || _player$current2 === void 0 || _player$current2.seekTo(position);
      }
    };
    return impReturn;
  }, []);
  useMediaAnalyticsProp ? useMediaAnalyticsProp({
    player: player === null || player === void 0 ? void 0 : player.current,
    title: trackingTitle,
    type: trackingType || (isLive ? VideoTypes.Live : videoType),
    src: typeof (rest === null || rest === void 0 ? void 0 : rest.url) === 'string' ? rest === null || rest === void 0 ? void 0 : rest.url : undefined
  }) : useMediaAnalytics({
    player: player === null || player === void 0 ? void 0 : player.current,
    title: trackingTitle,
    type: trackingType || (isLive ? VideoTypes.Live : videoType),
    src: typeof (rest === null || rest === void 0 ? void 0 : rest.url) === 'string' ? rest === null || rest === void 0 ? void 0 : rest.url : undefined
  });
  var _useState19 = useState(!excludeUiElements ? uiElements || defaultUiElements : defaultUiElements.filter(function (element) {
      return !(excludeUiElements !== null && excludeUiElements !== void 0 && excludeUiElements.includes(element));
    })),
    _useState20 = _slicedToArray(_useState19, 2),
    ui = _useState20[0],
    setUi = _useState20[1];
  useEffect(function () {
    setPlayerProps(_objectSpread2(_objectSpread2({}, playerProps), {}, {
      url: rest.url
    }));
  }, [rest.url]);
  useEffect(function () {
    if (!excludeUiElements) setUi(uiElements || defaultUiElements);
  }, [uiElements]);
  useEffect(function () {
    setUi(defaultUiElements.filter(function (element) {
      return !(excludeUiElements !== null && excludeUiElements !== void 0 && excludeUiElements.includes(element));
    }));
  }, [excludeUiElements]);
  useEffect(function () {
    if (player.current) {
      setCurrentPlayer(player.current);
    }
  }, [player]);
  useEffect(function () {
    // Hide ui on Mobile and show native controls
    if (BrowserUtil.isMobile()) {
      setUi(showPoster ? [VideoControl.PLAY_PAUSE_BIG] : []);
      setNativeControls(!noUi);
    }
  }, [showPoster]);
  useEffect(function () {
    if (!loading) {
      // check if autoplay is possible, or set video to muted
      canAutoPlay.video({
        inline: true
      }).then(function (_ref) {
        var result = _ref.result;
        if (!result && rest.playing && !rest.muted) {
          setPlayerProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
            playing: true,
            muted: true
          }));
        }
      });
      return function () {
        /*  removeMedia({ player: currentPlayer || null }); */
      };
    }
  }, [loading]);
  return jsx("div", {
    className: "cue-video-wrapper ".concat(loading ? 'cue-video-wrapper-loading' : ''),
    ref: videoWrapper
  }, loading && jsx("div", {
    className: "cue-video-loading"
  }, jsx(LoadingSpinner, null)), !unmutedLayerRemoved && showUnmuteButton && playerProps.muted && jsx("div", {
    className: "cue-video-dim"
  }, jsx(Button, {
    className: "cue-video-dim-button",
    styling: "videoDim",
    icon: "soundOff",
    onClick: function onClick() {
      setPlayerProps(_objectSpread2(_objectSpread2({}, rest), {}, {
        muted: false
      }));
      setUnmutedLayerRemoved(true);
    }
  }, "Unmute")), poster && showPoster && jsx(Image, {
    src: poster
  }), !noUi && jsx(VideoUi, {
    player: (player === null || player === void 0 ? void 0 : player.current) || null,
    playerProps: playerProps,
    updateProps: setPlayerProps,
    playerProgress: playerProgress,
    playerDuration: playerDuration,
    wrapper: (customWrapper === null || customWrapper === void 0 ? void 0 : customWrapper.current) || (videoWrapper === null || videoWrapper === void 0 ? void 0 : videoWrapper.current) || null,
    uiElements: ui,
    isLive: isLive
  }), jsx(ReactPlayer, _extends({
    ref: player
  }, playerProps, {
    onProgress: function onProgress(c) {
      onProgressUpdate && onProgressUpdate(c.playedSeconds);
      setPlayerProgress(c);
    },
    onEnded: function onEnded() {
      var _player$current3;
      setPlayerProps(_objectSpread2(_objectSpread2({}, playerProps), {}, {
        playing: false
      }));
      player === null || player === void 0 || (_player$current3 = player.current) === null || _player$current3 === void 0 || _player$current3.seekTo(0);
      setShowPoster(true);
    },
    onPlay: function onPlay() {
      return setShowPoster(false);
    },
    onDuration: setPlayerDuration,
    width: '100%',
    height: '100%',
    controls: nativeControls,
    config: {
      file: {
        hlsVersion: (hls === null || hls === void 0 ? void 0 : hls.version) || '1.4.12'
      }
    },
    onReady: function onReady() {
      if (!playerInited) {
        var _ref2;
        setLoading(false);
        if (startTime) (_ref2 = (player === null || player === void 0 ? void 0 : player.current) || null) === null || _ref2 === void 0 || _ref2.seekTo(startTime);
        setPlayerInited(true);
      }
    }
  })));
});
var VideoControl = /*#__PURE__*/function (VideoControl) {
  VideoControl["PLAY_PAUSE"] = "PLAY";
  VideoControl["PLAY_PAUSE_BIG"] = "PLAY_BIG";
  VideoControl["MUTE"] = "MUTE";
  VideoControl["VOLUME"] = "VOLUME";
  VideoControl["PROGRESS"] = "PROGRESS";
  VideoControl["FULLSCREEN"] = "FULLSCREEN";
  VideoControl["DURATION"] = "DURATION";
  return VideoControl;
}({});
var defaultUiElements = [VideoControl.PLAY_PAUSE, VideoControl.MUTE, VideoControl.PROGRESS, VideoControl.FULLSCREEN, VideoControl.DURATION];

export { Video, VideoControl, VideoTypes };
